import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { BkPage, fmtMoney, fmtTime, SmallBtn } from "@/components/bookkeeping/BkPage";

const STATUS_COLOR = { new: "#A3A3A3", matched: "#4CCC06", categorized: "#4CCC06", review: "#F5B700", posted: "#4CCC06", excluded: "#666" };

const Body = ({ entity }) => {
  const [accts, setAccts] = useState([]);
  const [acct, setAcct] = useState("");
  const [data, setData] = useState(null);
  useEffect(() => { setAcct(""); api(`/bookkeeping/connections?entity_id=${entity.id}`).then((d) => setAccts(d.bank_accounts)).catch(() => setAccts([])); }, [entity.id]);
  const load = useCallback(() => api(`/bookkeeping/bank/transactions?entity_id=${entity.id}${acct ? `&bank_account_id=${acct}` : ""}`).then(setData).catch((e) => toast.error(e.message)), [entity.id, acct]);
  useEffect(() => { setData(null); load(); }, [load]);
  return (
    <>
      <div className="flex flex-wrap items-center gap-3">
        <select data-testid="bk-txn-account-filter" value={acct} onChange={(e) => setAcct(e.target.value)} className="rounded-lg border border-[#333] bg-[#0F0F0F] px-3 py-2 text-sm text-white">
          <option value="">All accounts</option>
          {accts.map((a) => <option key={a.id} value={a.id}>{a.name} ••{a.mask}</option>)}
        </select>
        <span className="text-sm text-neutral-400" data-testid="bk-txn-total">{data ? `${data.total} transactions` : ""}</span>
        <SmallBtn onClick={load} data-testid="bk-txn-refresh">Refresh</SmallBtn>
      </div>
      <div className="overflow-x-auto rounded-xl border border-[#333]" data-testid="bk-txn-table">
        <table className="w-full text-sm">
          <thead className="bg-[#141414] text-left text-[11px] uppercase tracking-wider text-neutral-500">
            <tr><th className="px-3 py-2">Date</th><th className="px-3 py-2">Description</th><th className="px-3 py-2">Account</th><th className="px-3 py-2 text-right">Amount</th><th className="px-3 py-2">Status</th></tr>
          </thead>
          <tbody className="divide-y divide-[#1f1f1f]">
            {(data?.rows || []).map((t) => (
              <tr key={t.id} data-testid={`bk-txn-${t.id}`} className={t.removed ? "opacity-40" : ""}>
                <td className="whitespace-nowrap px-3 py-2 text-neutral-300">{t.posted_date}</td>
                <td className="px-3 py-2 text-white">{t.merchant_name || t.description}{t.pending && <span className="ml-2 text-[10px] font-bold text-[#F5B700]">PENDING</span>}</td>
                <td className="px-3 py-2 text-neutral-400">{accts.find((a) => a.id === t.bank_account_id)?.name || "–"}</td>
                <td className="whitespace-nowrap px-3 py-2 text-right font-bold" style={{ color: t.amount >= 0 ? "#4CCC06" : "#FFFFFF" }}>{fmtMoney(t.amount)}</td>
                <td className="px-3 py-2 text-xs font-bold" style={{ color: STATUS_COLOR[t.status] }}>{t.status}</td>
              </tr>
            ))}
          </tbody>
        </table>
        {data && data.rows.length === 0 && <p className="p-4 text-sm text-neutral-500" data-testid="bk-txn-empty">No bank transactions yet. Connect a bank on the Connections tab.</p>}
      </div>
      {data?.rows?.[0] && <p className="text-xs text-neutral-500">Last updated {fmtTime(data.rows[0].updated_at)}</p>}
    </>
  );
};

export default function Transactions() {
  return <BkPage title="Bank transactions" testId="bookkeeping-transactions">{({ entity }) => <Body entity={entity} />}</BkPage>;
}
